import { Component, EventEmitter, Input, Output } from '@angular/core';
import { KeyAndParams } from '../../model/key-and-params';

@Component({
  selector: 'app-slider-picker',
  templateUrl: './slider-picker.component.html',
  styleUrls: ['./slider-picker.component.scss']
})
export class SliderPickerComponent {

  @Input() unit: string = '';
  @Input() backgroundFn: (value: number, max?: number) => string;
  @Input() transformFn?: (value: number) => KeyAndParams;
  @Input() value: number;
  @Input() min: number = 0;
  @Input() max: number = 100;
  @Input() step: number = 1;
  @Input() disabled = false;
  @Output() valueChanged: EventEmitter<number> = new EventEmitter();

  change(event: number): void {
    this.valueChanged.emit(event);
  }
}
